export const toggleCollapsible = (collapsible: HTMLElement, targetState?: boolean) => {
  const innerContainer = collapsible.querySelector(
    "[data-collapsible-container]"
  ) as HTMLElement;
  const content = collapsible.querySelector("[data-collapsible-content]") as HTMLElement;

  if (!innerContainer || !content) {
    return;
  }
  /** Get currently set transition duration - differs as the collapsible should open slower than it closes */
  const getCurrentTransitionDuration = () => {
    const transitionDurationPropValue =
      getComputedStyle(innerContainer).getPropertyValue("transition-duration");

    let transitionDuration = 200;

    // If specified in seconds, convert to milliseconds
    if (transitionDurationPropValue.match(/\ds$/)) {
      transitionDuration =
        parseFloat(transitionDurationPropValue.replace("s", "")) * 1000;
    } else if (transitionDurationPropValue.match(/\dms$/)) {
      transitionDuration = parseFloat(transitionDurationPropValue.replace("ms", ""));
    }

    if (isNaN(transitionDuration)) {
      transitionDuration = 200;
    }

    return transitionDuration;
  };

  const shouldOpen =
    targetState !== undefined
      ? targetState
      : collapsible.getAttribute("aria-expanded") === "true";

  if (shouldOpen) {
    innerContainer.style.height = `${content.clientHeight}px`;
    collapsible.setAttribute("aria-expanded", "true");

    setTimeout(() => {
      innerContainer.style.height = "auto";
      innerContainer.style.overflow = "visible";
    }, getCurrentTransitionDuration());
  } else {
    innerContainer.style.height = `${content.clientHeight}px`;
    innerContainer.style.overflow = "hidden";
    collapsible.setAttribute("aria-expanded", "false");

    setTimeout(() => {
      innerContainer.style.height = "0";
    }, getCurrentTransitionDuration());
  }
};
